export default __webpack_public_path__ + "static/media/PenawaranProgram.e88ebf5f.png";